import React from "react";
import { Card, Text } from "@nextui-org/react";
import barrenPayLightLogo from "../../../assets/images/barrenPay-DarkLogo.png"
import Cookies from 'js-cookie';
import axios from "axios";
import { Link } from "react-router-dom";

const VisaCard = () => {
    const authToken = Cookies.get("authToken")
    const [Cards, setCards] = React.useState([])

    const reversedCards = [...Cards].reverse();

    const FetchTheCard = (() => {
        axios.get('https://sea-turtle-app-vo8po.ondigitalocean.app/cards',
            {
                headers: {
                    "Content-Type": "application/json",
                    "authToken": authToken
                },
            }
        )
            .then(function (response) {
                setCards(response.data)
                console.log(Cards)
            })
            .catch(function (error) {
                console.log(error);
            });
    })

    React.useEffect(() => {
        FetchTheCard()
    })

    return (
        <div className='mt-6'>
            <div className="space-y-5 sm:space-y-6">
                <div className="grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {reversedCards.map((card) => (
                       <Link to={card._id}>
                         <Card
                            isPressable
                            variant="bordered"
                            css={{ mw: "400px" }}
                            className="card theVisaCard bg-gray-100 rounded-lg"
                            key={card.id} // Make sure to add a unique key for each item in the array
                        >
                            <Card.Body>
                                <div className="text-xs text-gray-500 mb-1">CARD PURPOSE</div>
                                <div className="text-lg font-medium text-gray-700 mb-4">{card.cardpurpose}</div>
                                <div className="flex justify-between items-center">
                                    <div className="text-base md:text-lg lg:text-xl font-bold text-gray-700 card-number">
                                        {String(card.cardnumber).slice(0, 4)} **** **** {String(card.cardnumber).slice(-4)}
                                    </div>
                                </div>
                                <div className="flex justify-between items-center mt-4">
                                    <div>
                                        <img src={barrenPayLightLogo} alt="barrenPayLogo" className="h-8 barrenPayLightLogo" />
                                    </div>
                                    <div className="text-gray-600">
                                        <div className="text-xs font-medium">EXPIRES</div>
                                        <div className="text-sm font-bold">12/25</div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                       </Link>
                     
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VisaCard;
